
export default defineNuxtPlugin((nuxtApp) => {
  const { GTM_URL, GA_ID } = nuxtApp.$config.public

  /**
   * Creates the "Container loaded"/"gtm.js" event that needs to happen before the config event
   * @see https://developers.google.com/tag-platform/gtagjs#add_the_google_tag_to_your_website
   */
  gtag('js', new Date())

  gtag('config', GA_ID, {
    transport_url: GTM_URL,
    send_page_view: false,
    first_party_collection: true,
  })
})